import { useState, useCallback, useEffect } from 'react';

const DEFAULT_RANGE = [0, 1];
function useDataRange(getDataArray, defaultRange = DEFAULT_RANGE) {
    const [dataRange, setRange] = useState(defaultRange);
    const updateDataRange = useCallback(() => {
        var _a;
        const range = (_a = getDataArray()) === null || _a === void 0 ? void 0 : _a.getRange();
        if (!range)
            return;
        setRange(range);
    }, [getDataArray]);
    useEffect(() => {
        updateDataRange();
    }, [updateDataRange]);
    return {
        dataRange,
        updateDataRange,
    };
}

export { useDataRange as default };
